import React from 'react';
import { Card, CardContent } from '../../../Components/UI/card';
import { useDesktop } from '../../../Components/Common/IsDesktop';
import { getSentimentIcon, sentimentEmoji } from '../../../Utils/Utilities';
import { getRelativeDateText } from '../../../Utils/Utilities';
import { getThreadTypeMeta } from '../../../Utils/Utilities';
import { getThreadTypesArr } from '../../../Store/Reducers';
import { useSelector } from 'react-redux';
import { getThreadTypeIcon } from '../../../Utils/Utilities';
const FeedbackComponent = ({ feedbackScore, feedbackNotes, failureReason, threadDetail = null, isConnection = false}) => {
  const isDesktop = useDesktop();
  const threadTypesData = useSelector(getThreadTypesArr)

  // Don't render if feedbackScore is 0 or falsy
  if (!feedbackScore || feedbackScore === 0) {
    return null;
  }
  
  // Mobile version
  if (!isDesktop) {
    return (
      <div className="space-y-3">
        <Card className="border-sahi-border-color bg-sahi-white">
          <CardContent className="p-3 pt-3">
            {/* Header with Feedback text */}
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-lg font-semibold text-color">Sentiment</h3>
            </div>

            {/* Content sections */}
            <div className="space-y-2">
              {/* Notes Section */}
              <div className='flex justify-between'>
                <div className='flex items-center gap-2'>
                    {feedbackNotes && feedbackNotes.trim() && feedbackScore > 0 && (
                    <div className="space-y-1">
                        <p className="flex flex-wrap text-xs text-gray-600 leading-tight items-center gap-1">
                            <span className="inline-flex items-center">
                                {sentimentEmoji(feedbackScore)}
                            </span>
                            {failureReason &&
                                failureReason.trim() &&
                                feedbackScore >= 1 &&
                                feedbackScore <= 3 && (
                                <span className='font-bold'>{failureReason} - </span>
                            )}
                            <span className="italic break-words">{feedbackNotes}</span>
                        </p>
                    </div>
                    )}
                </div>
            </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  // Desktop version
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-color">Sentiment</h3>
      </div>

      <Card className="border-sahi-border-color bg-sahi-white">
        <CardContent className="p-3 md:pt-0">
          <div className="space-y-2">
            <div className='flex justify-between'>
                <div className='flex items-center gap-2'>
                    {feedbackScore > 0 && (
                    <div className="space-y-1">
                        <p className="flex flex-wrap text-xs leading-tight items-center gap-1 mb-2">
                            <span className="inline-flex items-center">
                                {sentimentEmoji(feedbackScore)}
                            </span>
                            {failureReason &&
                                failureReason.trim() &&
                                feedbackScore >= 1 &&
                                feedbackScore <= 3 && (
                                <span className='font-bold'> {failureReason} - </span>
                            )}
                            <span className="italic break-words"> {feedbackNotes}</span>
                        </p>
                       {(isConnection && threadDetail.thrTypeID > 0) && (
                          <p className="flex items-center text-xs text-gray-600 leading-tight gap-1 ml-1">
                            <span className="inline-flex items-center">
                              {getThreadTypeIcon(threadDetail.thrTypeID, threadTypesData, "h-4 w-4")}
                            </span>
                            <span className='ml-1'>
                              {threadDetail.thrReference !== 0 && `#${threadDetail.thrReference} - `}
                              {threadDetail.thrProduct} - {getRelativeDateText(threadDetail.thrFeedbackDT)}
                            </span>
                          </p>
                        )}
                    </div>
                    )}
                </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default FeedbackComponent;